// **  Initial State
const initialState = {
	data: {},
	loading: false
}

export const dashboardReducer = (state = initialState, action) => {
	switch (action.type) {
		case 'DASHBOARD_SET_INFO':
			return {
				...state,
				data: action.data
			}
		case 'DASHBOARD_INFO_LOADING_START':
			return {
				...state, loading: true
			}
		case 'DASHBOARD_INFO_LOADING_END':
			return {
				...state, loading: false
			}
		default:
			return state
	}
}
